import { path } from '@/src/utils/generalUtils/path'

const ClevertapReact = {
    initialize(accountId: string) {
        try {
            if (
                typeof window !== 'undefined' &&
                !path(['clevertap', 'account'], window) &&
                !path(['clevertap', 'event'], window)
            ) {
                window.clevertap = { event: [], profile: [], account: [], onUserLogin: [], notifications: [], privacy: [] }
                window.clevertap.account.push({ id: accountId })
                ;(function () {
                    const wzrk = document.createElement('script')
                    wzrk.type = 'text/javascript'
                    wzrk.async = true
                    wzrk.src = `${
                        document.location.protocol == 'https:'
                            ? 'https://d2r1yp2w7bby2u.cloudfront.net'
                            : 'http://static.clevertap.com'
                    }/js/clevertap.min.js`
                    const s = document.getElementsByTagName('script')[0]
                    s.parentNode?.insertBefore(wzrk, s)
                })()
            }
        } catch (error) {
            console.log(error)
        }
    },

    event(name: string, payload: any) {
        if (payload) {
            window.clevertap.event.push(name, payload)
        } else {
            window.clevertap.event.push(name)
        }
    },

    profile(payload: any) {
        window.clevertap.profile.push(payload)
    },

    logout() {
        window.clevertap?.logout?.()
    }
}

export default ClevertapReact
